import { HTTPClient } from '../utils/request'

export default {
  qualp: ({ payload }) => HTTPClient.post(`/qualp`, payload),
  qualpMass: ({ payload }) => HTTPClient.post(`/qualp/csv`, payload),
  qualpMassExample: () => HTTPClient.get(`/qualp/csv/example`),
  logTolls: ({ query }) => HTTPClient.get(`/logTolls${query}`)
}
